import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "Components/ReactstrapSlim";
import * as Icons from "Components/Icons";
import { useShadowToggle } from "Hooks";
import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";
import { isSysAdminSelector } from "Utils/selectors";
import uikitcolors from "Styles/UIKit/uikit-colors.module.scss";
import { AdministrationMenu } from "./AdministrationMenu";
import { ConfigurationMenu } from "./ConfigurationMenu";
import { modifiers } from "./Header";

const sidenavTogglesClassName = "sidenav-toggled";
function sidebarClose() {
   document.body.classList.remove(sidenavTogglesClassName);
};

interface HeaderSuperUserProps {
   onOpen?: () => void;
   isEnterpriseManagment?: boolean
}

export const HeaderSuperUser: React.FC<HeaderSuperUserProps> = ({ onOpen, isEnterpriseManagment }) => {
   const isMobileXs = useMediaBreakpointDown("xs");
   const isMobileSm = useMediaBreakpointDown("sm");
   const [isDropdownOpen, setDropdownOpen] = useState(false);
   const [beforeDropDownOpen, setBeforeDropDownOpen] = useState<string>();
   const toggleId = "dropdown-toggle-su-ep";
   const isSysAdmin = useSelector(isSysAdminSelector);

   useEffect(() => {
      if (isDropdownOpen && isMobileXs) {
         setBeforeDropDownOpen(document.body.style.overflow);
      }

      if (isDropdownOpen && isMobileXs && document.body.style.overflow === "hidden") {
         document.body.style.overflow = "auto";
      } else if (!isDropdownOpen && isMobileXs && beforeDropDownOpen) {
         document.body.style.overflow = beforeDropDownOpen;
      }
   }, [isDropdownOpen]);

   function toggleDropdown() {
      setDropdownOpen(!isDropdownOpen);
      if (onOpen) {
         onOpen();
      }
   }

   useShadowToggle(toggleId, isDropdownOpen, isEnterpriseManagment);  

   return <UncontrolledDropdown isOpen={isDropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle color="secondary" id={toggleId} className="header-su-toggle btn-transparent" aria-label="administrator menu">
         <Icons.Settings color={uikitcolors["deep-sea"]} />
      </DropdownToggle>
      <DropdownMenu right modifiers={modifiers} className="header-su-popup">
         {
            <>
               <AdministrationMenu columnCount={isMobileSm ? isMobileXs ? 1 : 2 : 3} />
               {
                  isSysAdmin
                  ? <ConfigurationMenu columnCount={isMobileSm ? isMobileXs ? 1 : 2 : 3} />
                  : null
               }
            </>
         }
      </DropdownMenu>
   </UncontrolledDropdown>
}